var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw:flex tw:items-center tw:justify-center tw:text-xs"},[_vm._v("\n    "+_vm._s(_vm.from)+" - "+_vm._s(_vm.to)+" de "+_vm._s(_vm.total)+" resultados\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }